import { Modal, Button, Form } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import { IReportItem } from '../../../model/report/Report-item';

interface IModalReject {
    showModal: boolean;
    setModalData: (args: any) => void;
    rejectReport: (updatedReport: IReportItem) => void;
    report: IReportItem;
}

export default function ModalReportReject({ showModal, setModalData, rejectReport, report }: IModalReject) {
    const [selectedReason, setSelectedReason] = useState(
        report.additionalPost ? report?.rejectReason : report?.event?.rejectReason
    );

    useEffect(() => {
        setSelectedReason(report.additionalPost ? report?.rejectReason : report?.event?.rejectReason);
    }, [report]);

    const isRejectButtonDisabled = !selectedReason?.trim();

    return (
        <Modal show={showModal} onHide={() => setModalData((prev: any) => ({ ...prev, showModal: false }))} centered>
            <Modal.Header closeButton>
                <Modal.Title>Reject</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="rejectReason">
                        <Form.Label>Enter Rejection Reason</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={selectedReason}
                            onChange={e => setSelectedReason(e.target.value)}
                            placeholder="Enter reason for rejection"
                            maxLength={250}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant="outline-primary"
                    onClick={() => setModalData((prev: any) => ({ ...prev, showModal: false }))}
                >
                    Close
                </Button>
                <Button
                    variant="danger"
                    onClick={() => rejectReport({ ...report, rejectReason: selectedReason })}
                    disabled={isRejectButtonDisabled}
                >
                    Reject
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
